import { useFormContext } from "react-hook-form";

import Box from "ds/components/Box";
import FullScreenModalBody from "ds/components/FullScreenModal/Body";
import FullScreenModalBodyHeader from "ds/components/FullScreenModal/BodyHeader";

import { ContextCreationWizardStepName } from "../constants";
import NewContextFooter from "../Footer";
import { useSaveContext } from "../hooks/useSaveContext";
import { ContextFormFields } from "../types";
import NewContextSummaryAttached from "./Attached";
import NewContextSummaryDetails from "./Details";
import NewContextSummaryEnvironment from "./Environment";
import NewContextSummaryHooks from "./Hooks";

const NewContextSummary = () => {
  const { handleSubmit } = useFormContext<ContextFormFields>();

  const [saveContext, isSavingContext] = useSaveContext(ContextCreationWizardStepName.Summary);

  return (
    <>
      <FullScreenModalBody>
        <FullScreenModalBodyHeader
          title="Summary"
          description="Please verify your context setup. Once context is created you still will be able to edit it."
        />

        <Box direction="column" gap="large" margin="0 0 large">
          <NewContextSummaryDetails />
          <NewContextSummaryAttached />
          <NewContextSummaryEnvironment />
          <NewContextSummaryHooks />
        </Box>
      </FullScreenModalBody>
      <NewContextFooter
        onCreateContextClick={handleSubmit(saveContext)}
        isCreatingContext={isSavingContext}
      />
    </>
  );
};

export default NewContextSummary;
